import { ChevronLeft, ChevronRight } from 'lucide-react'
import React from 'react'
import { cn } from '../../../utils/classnames'

function getPaginationPages(current, total) {
  current = Number(current)
  total = Number(total)

  const pages = []

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i)
    return pages
  }

  pages.push(1)

  if (current <= 4) {
    for (let i = 2; i <= 5; i++) pages.push(i)
    pages.push('...')
  } else if (current >= total - 3) {
    pages.push('...')
    for (let i = total - 4; i < total; i++) pages.push(i)
  } else {
    pages.push('...')
    pages.push(current - 1, current, current + 1)
    pages.push('...')
  }

  pages.push(total)

  return pages
}

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = getPaginationPages(currentPage, totalPages)

  return (
    <div className="flex justify-center items-center gap-1 flex-wrap text-lg text-blueDarker font-jost">

      {/* Anterior */}
      <button
        className={`px-2 font-semibold flex items-center transition-opacity ${
          currentPage === 1
            ? 'opacity-50 cursor-default pointer-events-none'
            : 'hover:opacity-80'
        }`}
        onClick={() => {
          if (currentPage > 1) onPageChange(currentPage - 1)
        }}
      >
        <ChevronLeft strokeWidth={2} size={20} className="text-blueDarker mr-3" />
        Anterior
      </button>

      {/* Páginas */}
      {pages.map((p, index) =>
        p === '...' ? (
          <span key={`dots-${index}`} className="w-6 text-center select-none">...</span>
        ) : (
          <button
            key={p}
            className={cn(
              'w-6 text-center font-light transition-opacity',
              Number(p) === Number(currentPage)
                ? 'text-blueDarker font-semibold'
                : 'hover:opacity-80'
            )}
            onClick={() => {
              onPageChange(Number(p))
            }}
          >
            {p}
          </button>
        )
      )}

      {/* Próxima */}
      <button
        className={`px-2 font-semibold flex items-center transition-opacity ${
          currentPage === totalPages
            ? 'opacity-50 cursor-default pointer-events-none'
            : 'hover:opacity-80'
        }`}
        onClick={() => {
          if (currentPage < totalPages) onPageChange(currentPage + 1)
        }}
      >
        Próxima
        <ChevronRight strokeWidth={2} size={20} className="text-blueDarker ml-3" />
      </button>
    </div>
  )
}

export default Pagination
